import { Grid, Typography, useTheme } from '@mui/material';
import { IOrder, IPrescription } from 'API';
import { useIsDesktop } from 'Hooks';
import parse from 'html-react-parser';

interface IPrescriptionStatusExtraInfoProps {
  item: IPrescription | IOrder;
}

export const PrescriptionStatusExtraInfo = (
  props: IPrescriptionStatusExtraInfoProps
) => {
  const theme = useTheme();
  const isDesktop = useIsDesktop();

  const { item } = props;

  const currentStepIndex = () =>
    item.statuses.findIndex(
      (status) => status.calcStatus === item.currentStatus
    );

  return (
    <Grid
      container
      direction={'column'}
      sx={{
        background: isDesktop ? 'rgba(198, 211, 219, 0.28)' : '#F2F9FF',
        border: '1px solid rgba(198, 211, 219, 0.8)',
        padding: '24px 0',
        marginTop: '25px',
        borderRadius: '8px',
        [theme.breakpoints.up('sm')]: {
          padding: '28px 0',
          marginTop: '32px',
        },
      }}
    >
      <Typography
        variant='h3'
        textAlign='center'
        fontWeight={isDesktop ? 400 : 700}
        component='h3'
      >
        {parse(item.statuses[currentStepIndex()]?.description || '')}
      </Typography>
    </Grid>
  );
};
